<template>
  <div :id="id + '_rep'" class="cat-repeater cat-repeater-table-slim">
    <cat-hint v-if="hint" :id="id + '_hint'" :text="hint" />
    <cat-help
      v-if="inlineHelp && inlineHelp.text"
      :id="id + '_help'"
      :heading="inlineHelp.title"
      :text="inlineHelp.text"
    />

    <table
      v-if="rows.length > 0 || header"
      :class="_table_class"
      :role="roleList ? 'list' : null"
      :aria-label="roleList ? roleListLabel : null"
    >
      <caption v-if="header" :role="roleList ? 'presentation' : null">
        <span class="visually-hidden">{{ header }}</span>
      </caption>
      <thead v-if="header" :role="roleList ? 'presentation' : null">
        <tr>
          <th :class="_header_class" :colspan="numColumns">
            <div>{{ header }}</div>
            <div v-if="$slots.filters" class="repeater-filters">
              <slot name="filters" />
            </div>
          </th>
        </tr>
      </thead>
      <tbody :role="roleList ? 'presentation' : null">
        <slot></slot>
      </tbody>
    </table>

    <cat-pagination
      v-if="paging && rows.length > 0"
      :id="id"
      :paging="paging"
      :pagination="pagination"
      class="pln"
      @ui-repeater-pagination-update="pageSelect"
    />
    <cat-error
      v-if="rows.length === 0"
      class="text-l"
      :alert-icon="emptyIcon ? emptyIcon : 'checklist'"
      :center="false"
      :outlined="false"
      :plain="false"
      :transparent="true"
    >
      <div v-if="noItemsHeader" class="highlightLabel size-r mtn mbt">
        {{ noItemsHeader }}
      </div>
      <span v-if="noItemsText" class="text-sm">
        {{ noItemsText }}
      </span>
    </cat-error>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import CatPagination from "./catPagination";
import CatHelp from "@/components/utilities/help.vue";
import CatHint from "@/components/utilities/hint";
export default defineComponent({
  name: "CatRepeaterTableSlim",
  components: {
    CatPagination,
    CatHelp,
    CatHint
  },
  props: {
    id: {
      type: [String, Number]
    },
    paging: {
      type: Boolean,
      default: false
    },
    pagination: [Object],
    numColumns: [Number],
    columnWidths: [Array],
    rows: [Array],
    header: String,
    noItemsHeader: String,
    noItemsText: String,
    stackSmall: {
      type: Boolean,
      default: false,
      description: "Displays 'Portfolio' header on mobile devises"
    },
    stackMaxSmall: {
      type: Boolean,
      default: false
    },
    stackMaxMedium: {
      type: Boolean,
      default: false
    },
    stackMaxLarge: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    },
    plain: {
      type: Boolean,
      default: false
    },
    roleList: {
      type: Boolean,
      default: false,
      description: "Changes the semantics of the table to a list role"
    },
    roleListLabel: {
      type: String,
      description:
        "The label for the screenreader to identify the list if using list role"
    },
    inlineHelp: {
      type: Object,
      description: "Inline help details for this repeater."
    },
    hint: {
      type: String,
      description: "Hint details for this repeater."
    },
    emptyIcon: {
      type: String,
      default: "checklist",
      description: "The name of the icon for the empty message."
    }
  },
  computed: {
    _table_class: function () {
      return {
        tableSlim: true,
        table: true,
        "stack-small": this.stackSmall,
        "stack-max-small": this.stackMaxSmall,
        "stack-max-medium": this.stackMaxMedium,
        "stack-max-large": this.stackMaxLarge,
        plain: this.plain,
        dense: this.dense
      };
    },
    _header_class: function () {
      return {
        slimTableHeader: true
      };
    },
    _columns: function () {
      var result = [];
      for (var i = 0; i < this.numColumns; i++) {
        result.push({
          width: this.columnWidths ? this.columnWidths[i] : null
        });
      }
      return result;
    }
  },
  methods: {
    pageSelect: function (event) {
      this.$emit("ui-repeater-pagination-update", event);
    }
  }
});
</script>
